export enum GameFilterType {
    Unknown = 0,
}

export enum GameFilterRegion {
    Unknown = 0,
}

export enum GameFilterAvailability {
    Unknown = 0,

    // Bit flags (must match backend [Flags] enum)
    BuyPage = 1 << 0,
    PendingPage = 1 << 1,
    InventoryPage = 1 << 2,
    SalePage = 1 << 3,
    PlaceBidPage = 1 << 4,
    MyOrdersPage = 1 << 5,
    CreateOrder = 1 << 6,
    Profile = 1 << 7,
    AllBidsPage = 1 << 8,
    SkinPage = 1 << 9,

    // Composite values (backend convenience members)
    WithoutAllOrders = BuyPage | SalePage | PendingPage | InventoryPage | Profile,
    WithoutCreateOrder = BuyPage | PlaceBidPage | AllBidsPage | SalePage | PendingPage | InventoryPage | MyOrdersPage | Profile,
    WithoutPlaceBid = BuyPage | AllBidsPage | CreateOrder | SalePage | PendingPage | InventoryPage | MyOrdersPage | Profile,
    All = BuyPage | PlaceBidPage | AllBidsPage | CreateOrder | SalePage | PendingPage | InventoryPage | MyOrdersPage | Profile | SkinPage,
}

export enum FilterColorType {
    Unknown = 0,
}

export interface AdminGameFilterInfo {
    id: number;
    gameId: number;
    groupNameRu: string;
    groupNameEn: string;
    groupType: string;
    titleRu?: string | null;
    titleEn?: string | null;
    filterType: GameFilterType | number;
    icon?: string | null;
    filterRegion: GameFilterRegion | number;
    availability: GameFilterAvailability | number;
    min?: number | null;
    max?: number | null;
    color?: string | null;
    colorType?: FilterColorType | number;
    textColor?: string | null;
    order: number;
    groupOrder: number;
    defaultValue: boolean;
}

